import React, { useState, useContext, useEffect } from 'react';
import { usersPathTo } from '../utils/Api';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, TextField, Typography, Box } from '@mui/material';
import FormBox from './building_blocks/FormBox';
import queryString from 'query-string';
import SnackbarContext from '../contexts/SnackbarContext';


const PasswordEdit = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const resetPasswordToken = queryString.parse(location.search).reset_password_token;
  const { openSnackbar } = useContext(SnackbarContext);

  useEffect(() => {
    if (localStorage.getItem('forgot_password_email')) {
      setEmail(localStorage.getItem('forgot_password_email'))
    }
  })

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  
  const handlePasswordConfirmationChange = (e) => {
    setPasswordConfirmation(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  }

  const handleSubmit = (e) => {
    console.log(resetPasswordToken);
    e.preventDefault();
    usersPathTo.reset_password({
      user: { email: email, password: password, password_confirmation: passwordConfirmation, reset_password_token: resetPasswordToken }
    }).then(result => {
      navigate("/login", { replace: true });
      openSnackbar("Senha redefinida com sucesso! Faça login novamente.", "success");
    }, error => {})
  };

  return (
    <FormBox>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Typography variant="h5" color="primary">Redefinir Senha</Typography>
        <Box mt={2} sx={{maxWidth: '200px'}}>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Email"
              variant="outlined"
              type="email"
              value={email || ''}
              onChange={handleEmailChange}
              fullWidth
              disabled
              sx={{marginTop: '8px;'}}
            />
            <TextField
              label="Nova senha"
              variant="outlined"
              type="password"
              value={password || ''}
              onChange={handlePasswordChange}
              fullWidth
              sx={{marginTop: '8px;'}}
            />
            <TextField
              label="Confirmar nova senha"
              variant="outlined"
              type="password"
              value={passwordConfirmation || ''}
              onChange={handlePasswordConfirmationChange}
              fullWidth
              sx={{marginTop: '8px;'}}
            />
            <Box mt={2}>
              <Button variant="contained" type="submit" >Salvar</Button>
            </Box>
          </form>
        </Box>
      </Box>
    </FormBox>
  );
};

export default PasswordEdit;